export const iconFontAwesomeMedicalHealthCrutch = (
	<i className="fa-solid fa-crutch"></i>
);
